export default "__VITE_ASSET__fcb48cd7__"